import styled from 'styled-components/macro'
import { media, em, rem } from '../../utils/styles'
import MainWrapper from '../MainWrapper'

const HeaderWrapper = styled(MainWrapper)`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  height: ${em(70)};

  ${media('tablet')`
    padding: 0 ${rem(36)};
  `}
`

export default HeaderWrapper
